import Domen from '../../../stores/Domen';
import GlobalState, { changePortraitsheduledeploynameAll, changeActivePortraits } from '../../../stores/GlobalState';


  


export async function updateDataPortrait() {
    const token = localStorage.getItem("token");
    localStorage.setItem("countactivetime", Date.now());
    var height = window.innerHeight;
    var limit = Math.trunc((height*1-370)/35);
    const response = await fetch(
        `${Domen.url}portraits/table/demo?page=${GlobalState.numpagesdatasetsportraits}&limit=${limit}`,
        {
            method: 'GET',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json',
            }
        }
    );

    if (response.status === 200) {
        const data = await response.json();

        if (data?.deploymentInfo?.[0]) {
            const info = data.deploymentInfo[0];
            changePortraitsheduledeploynameAll(
                info.bigquery_table_name,
                info.periodicity,
                info.start_time,
                info.id
            );
        }

        changeActivePortraits(data);
    } else {
        console.error("Не вдалося оновити портрети:", response.status);
    }
}
